module.exports = __webpack_public_path__ + "img/logo-dark.71095913.png";